/**
 * Merdeka ke-69 campaign theme (Ansa-Support #54).
 *
 * ANSA asked for an Independence Day visual on the Ansa App icon from
 * 27 August 2026 to 17 September 2026 inclusive, reverting to the existing
 * icon afterwards without a further deploy. The window is therefore evaluated
 * at runtime rather than baked into the build.
 *
 * Nothing here overwrites an existing asset. The campaign icons live under
 * public/merdeka-2026/; outside the window the original <link> tags in
 * public/index.html are left untouched, so "revert" is the do-nothing path.
 */

// Malaysia has no DST, so MYT is a fixed UTC+8 and plain UTC instants are exact.
const WINDOW_START_UTC = Date.UTC(2026, 7, 26, 16, 0, 0); // 27 Aug 2026 00:00 MYT
const WINDOW_END_UTC = Date.UTC(2026, 8, 17, 16, 0, 0); //  18 Sep 2026 00:00 MYT (end of 17 Sep)

const BASE = `${process.env.PUBLIC_URL || ""}/merdeka-2026`;

/**
 * REACT_APP_MERDEKA_THEME lets ANSA see the theme on staging outside the dates,
 * and lets us pull it on production without waiting for a revert build.
 *   "on"   — force the campaign icons
 *   "off"  — force the standard icons
 *   unset / "auto" — follow the dates above
 */
export function isMerdekaWindow(now = new Date()) {
  const override = (process.env.REACT_APP_MERDEKA_THEME || "auto").toLowerCase();
  if (override === "on") return true;
  if (override === "off") return false;

  const t = now.getTime();
  return t >= WINDOW_START_UTC && t < WINDOW_END_UTC;
}

function replaceLinks(rels, next) {
  const head = document.head;
  if (!head) return;

  rels.forEach((rel) => {
    head
      .querySelectorAll(`link[rel~="${rel}"]`)
      .forEach((el) => el.parentNode.removeChild(el));
  });

  next.forEach((attrs) => {
    const link = document.createElement("link");
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.appendChild(link);
  });
}

/**
 * Swaps the browser/PWA icon set for the campaign one. Safe to call on every
 * boot: outside the window it returns false and touches nothing.
 */
export function applyMerdekaTheme(now = new Date()) {
  if (typeof document === "undefined") return false;
  if (!isMerdekaWindow(now)) return false;

  replaceLinks(
    // rel~= matches whole words, so "icon" also catches rel="shortcut icon".
    ["icon", "apple-touch-icon", "manifest"],
    [
      { rel: "icon", type: "image/png", sizes: "32x32", href: `${BASE}/favicon-32x32.png` },
      { rel: "icon", type: "image/png", sizes: "16x16", href: `${BASE}/favicon-16x16.png` },
      { rel: "apple-touch-icon", sizes: "180x180", href: `${BASE}/apple-touch-icon.png` },
      { rel: "manifest", href: `${BASE}/manifest.json` },
    ]
  );

  return true;
}
